<template>
	<div class="select-btn">
		<func-btn
			:title="title"
			:icon="icon"
			:isTitleLeft="isTitleLeft"
			:isSelectLeft="isSelectLeft"
			@click="toggle"
			v-on-clickaway="close"
		></func-btn>
		<transition name="select">
			<div v-if="isSelectBoxShow" class="select-list" :class="{ 'select-left': isSelectLeft }">
				<slot></slot>
			</div>
		</transition>
	</div>
</template>

<script>
import funcBtn from '../func-btn'
export default {
	name: 'selectBtn',
	components: {
		funcBtn
	},
	model: {
		prop: 'selectValue',
		event: 'change'
	},
	props: {
		selectValue: {
			type: [String, Number, Array],
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		},
		isTitleLeft: {
			type: Boolean,
			default: false
		},
		isSelectLeft: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isSelectBoxShow: false
		}
	},
	computed: {},
	watch: {},
	methods: {
		toggle() {
			this.isSelectBoxShow = !this.isSelectBoxShow
		},
		close() {
			this.isSelectBoxShow = false
		},
		optionClick(e) {
			let selectValue = e
			if (this.multiple) {
				let selectArr = this.selectValue
				if (this.selectValue.includes(e)) {
					selectArr.splice(this.selectValue.indexOf(e), 1)
				} else {
					selectArr = this.selectValue.concat([e])
				}
				selectValue = selectArr
			}
			this.$emit('change', selectValue)
		}
	},
	created() {},
	mounted() {}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
